import { createSelector } from 'reselect';

const key = 'wishList';
const domain = (state) => state.global[key];

const selectorAll = createSelector([domain], (list) => list);

const makeSelectAll = () => selectorAll;

export { makeSelectAll };
